import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react'
import {
    CulturalListItem,
    SearchHistoryItem,
    SearchRecommendItem,
} from 'src/components/CulturalComponent'
import { Empty, Input, Pagination } from 'antd'

import { useHistory } from 'react-router-dom'
import icon_delete from '../../assets/icon_delete.svg'
import axios from 'axios'
import './PcIndex.scss'
import PcFooter from '../PcFooter/PcFooter'
interface IndexProps {}
const { Search } = Input

const PcIndex: FunctionComponent<IndexProps> = () => {
    const history = useHistory()
    const [currentPage, setCurrentPage] = useState(1)
    const [tableTotal, setTableTotal] = useState(0)
    const [listData, setListData] = useState([])

    // 搜索区域
    const [searchBarValue, setSearchBarValue] = useState('')

    const searchInputClick = useCallback((inputValue?: string) => {
        setSearchBarValue(inputValue)
        setSearchFlag(true)
    }, [])

    // 跳转到详情
    const jumpToDetails = useCallback(item => {
        history.push({
            pathname: '/detail',
            search: `id=${item.id}`,
        })
    }, [])
    // 自动触发
    const searchListData = useCallback(
        async (returnData?: boolean) => {
            // 发送 POST 请求
            const res = await axios({
                method: 'post',
                url: '/api/display',
                data: {
                    page: currentPage,
                    pageSize: 12,
                    keyword: searchBarValue,
                },
            })
            if (res.data.code !== 0) {
                return
            }

            if (returnData) {
                return res.data.data
            }
            setListData(res.data.data.items)
            setTableTotal(res.data.data.total)
        },
        [searchBarValue, currentPage],
    )

    const [searchFlag, setSearchFlag] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    useEffect(() => {
        if (searchFlag) {
            searchListData()
            setSearchFlag(false)
        }
    }, [searchFlag])
    useEffect(() => {
        setSearchFlag(true)
    }, [])
    return (
        <>
            <div className="cultural-index-pc">
                <div className="cultural-index-title">
                    <h4>3D文物展示系统</h4>{' '}
                    <Search
                        placeholder="搜索"
                        onSearch={value => {
                            setCurrentPage(1)
                            setSearchValue(value)
                            searchInputClick(value)
                        }}
                        style={{ width: 320 }}
                    />
                </div>
                <div className="cultural-list-wrapper">
                    <div className="cultural-list">
                        {listData.length === 0 ? (
                            <Empty className="empty" description="暂无结果" />
                        ) : (
                            <>
                                {listData.map(item => {
                                    return (
                                        <CulturalListItem
                                            key={item.id}
                                            img={item.cover}
                                            name={item.name}
                                            onClick={() => {
                                                jumpToDetails(item)
                                            }}
                                        ></CulturalListItem>
                                    )
                                })}
                            </>
                        )}
                        {!!searchValue && (
                            <span className="search">“{searchValue}”的搜索结果：</span>
                        )}
                    </div>
                </div>
                <Pagination
                    className="pagination"
                    current={currentPage}
                    onChange={value => {
                        setCurrentPage(value)
                        setSearchFlag(true)
                    }}
                    pageSize={12}
                    total={tableTotal}
                />
            </div>
            <PcFooter></PcFooter>
        </>
    )
}

export default PcIndex
